// ignoring this rule as we have a global to not track any user info
/* eslint-disable no-underscore-dangle */

export default function(
  event,
  eventCategory,
  eventAction,
  eventLabel = 'unknown',
  eventValue
) {
  if (typeof window === 'undefined') return

  // @ts-ignore
  if (window.__gtmDontTrack || !window.dataLayer) return

  let track = {}
  if (event) track = { ...track, event }
  if (eventCategory) track = { ...track, eventCategory }
  if (eventAction) track = { ...track, eventAction }
  if (eventLabel) track = { ...track, eventLabel }
  if (eventValue) track = { ...track, eventValue }
  if (eventLabel === '') track = { ...track, eventLabel: 'unknown' }

  // @ts-ignore
  window.dataLayer.push(track)
}
